/* src/app/FW/components/reports/report-list/report-list.component.scss */
::ng-deep th.mat-mdc-header-cell .mat-sort-header-container.mat-sort-header-sorted .mat-sort-header-arrow {
  opacity: 1 !important;
  transform: translateY(0) !important;
}
.table tr.active td {
  background-color: #bad7ff !important;
}
table {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  min-width: 500px;
  background-color: white;
}
.table-row {
  height: 30px !important;
}
th.mat-mdc-header-cell {
  text-align: left;
  max-width: 300px;
  height: 30px !important;
}
.mat-mdc-row:hover {
  background-color: #e8e8e8 !important;
}
.mat-mdc-header-cell {
  color: black;
  font: bold 14px/20px Roboto;
  letter-spacing: 0.0179em;
  height: 30px !important;
}
.table-row:focus {
  background: #bad7ff !important;
  outline: none;
}
.btn-default {
  color: #000000;
  background-color: #f2f2f2;
  border-color: #e8e8e8;
  height: 30px;
  text-align: center;
  line-height: 14px;
  text-transform: none;
  font-size: 16px;
}
.btn3d {
  position: relative;
  top: -6px;
  border: 0;
  transition: all 40ms linear;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 2px;
  margin-right: 2px;
}
.btn3d.btn-default {
  color: #666666;
  box-shadow:
    0 0 0 1px #ebebeb inset,
    0 0 0 2px rgba(255, 255, 255, 0.1) inset,
    0 8px 0 0 #BEBEBE,
    0 8px 8px 1px rgba(0, 0, 0, 0.2);
  background-color: #f2f2f2;
}
.btn3d.btn-default:active,
.btn3d.btn-default.active {
  color: #666666;
  box-shadow:
    0 0 0 1px #ebebeb inset,
    0 0 0 1px rgba(255, 255, 255, 0.15) inset,
    0 1px 3px 1px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
}
.btn3d:active:focus,
.btn3d:focus:hover,
.btn3d:focus {
  -moz-outline-style: none;
  outline: medium none;
}
.btn3d:active,
.btn3d.active {
  top: 2px;
}
.btntest {
  background-image: linear-gradient(#ffffff, #bdbdbd);
}
.formcontrol {
  border: 1px solid silver;
  border-radius: 5px;
  width: 215px;
}
/*# sourceMappingURL=report-list.component.css.map */
